import { useEffect } from "react";
import { Select } from "antd";
import { useTranslation } from "react-i18next";
import { ObjectHelper } from "../../utils/ObjectHelper";
import { enmConfirmationStatus } from "../../models/enums/ConfirmationStatus";

export type ConfirmStatusSelectProps = {
    onChange?: Function;
    value?: any;
    mode?: "multiple" | "tags" | undefined;
    specificTypes?: enmConfirmationStatus[];
    defaultValue?: string | string[];
    maxTagCount?: number;
}


export const ConfirmStatusSelect = (props: ConfirmStatusSelectProps) => {
    const { t } = useTranslation();

    useEffect(() => {
    }, [props]);

    const onFocus = () => {
        let i;
        const el = document.getElementsByClassName(
            "ant-select-selection-search-input"
        );
        for (i = 0; i < el.length; i++) {
            el[i].setAttribute(
                "autocomplete",
                "registration-select"
            );
        }
    }

    let confirmStatuses: { name: string; id: number }[] = props.specificTypes ? ObjectHelper.getEnumKeyValuesForSpecificTypes(enmConfirmationStatus, props.specificTypes) : ObjectHelper.enumToObjectArray(enmConfirmationStatus);

    return (
        <>
            <Select
                mode={props.mode}
                size="middle"
                onFocus={onFocus}
                maxTagCount={props.maxTagCount ?? undefined}
                value={props.value ? props.mode == "multiple" ? props.value as string[] : props.value as string : props.defaultValue}
                onChange={(value: string | string[]) => props.onChange ? props.onChange(value) : undefined}
                showSearch
                placeholder={t("common.chooseConfirmationStatus")}
                filterOption={(input, option) =>
                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                }
                options={confirmStatuses?.map(h => Object.assign(h, {
                    label: h.name,
                    value: h.id.toString()
                }))}
            />
        </>
    )
}